/**
 * Native container shadow for the Toast card, applied via the View's
 * `nativeProps.style` on React Native — NativeWind v4 can't reliably compile a
 * CSS box-shadow to RN shadow props, so web uses the `shadow-toast` Tailwind
 * token while native uses this raw style object (mirrors `Button.shadows.ts`).
 *
 * Matches the Figma Toast container shadow `0 8px 20px rgba(0,0,0,0.05)`. The
 * shadow is variant-independent (every variant shares the same soft drop).
 *
 * RN style fields:
 *   shadowColor / shadowOffset / shadowOpacity / shadowRadius – iOS
 *   elevation – Android (drives a system shadow whose darkness is elevation-,
 *     not opacity-, based; tune on the Android sim — 0.05α is intentionally faint).
 */
export const TOAST_NATIVE_SHADOW = {
  shadowColor: '#000000',
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.05,
  shadowRadius: 20,
  elevation: 6,
} as const;
